<template>
  <v-container background fluid pa-3 v-scroll="onScrollFunction" class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top: 7px; color: #fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
    <filter-component :json_data="form_dialog_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

    <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <!-- <v-tooltip top> -->
        <v-btn
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="onHandleDialog(true, 'create', null)"
        >
          <v-icon>fa-plus</v-icon>
        </v-btn>
        <!-- <span>{{$t('create')}}</span>
        </v-tooltip> -->
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top: 5rem; margin-bottom: 15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex
          xs12
          md4
          offset-md4
          lg2
          offset-lg5
          class="adddoc-hover"
          style="cursor: pointer"
          v-if="permission_edit == true || admin == 'true'"
        >
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top: 40px; padding-bottom: 40px"
              >
                <v-icon style="font-size: 80px" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color: #2195f3">
                  {{ $t("AddChangeSalary") }}
                </h3>
              </div>
            </template>
            <span>{{ $t("ClickFor") }} {{ $t("AddChangeSalary") }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex
            lg4
            md6
            sm12
            xs12
            pa-1
            v-for="(item, index) in table_data"
            :key="index"
            @click="
              '';

            "
          >
            <v-card
              class="coco-box-shadow"
              style="border-left: 5px solid #4f8abc; border-radius: 5px"
            >
              <v-layout row wrap class="coco-list-layout" pa-3>
                <v-flex lg1 md1 sm1 xs2 text-xs-center style="margin: auto">
                  <v-icon :size="50" style="color: #4f8abc">
                    fas fa-file-invoice-dollar</v-icon
                  >
                </v-flex>
                <v-flex lg7 md8 sm8 xs7>
                  <v-layout row wrap>
                    <v-flex lg12 md12 sm12 xs12 pa-1>
                      <!-- <span
                        class="coco-list-label-text"
                      >{{isEmpty(item.emp_code)? item.emp_code : 'emp_code'}}:</span>-->
                      <span> {{ item.firstName }} {{ item.lastName }}</span>
                      <span
                        v-if="item.nick_name != '' && item.nick_name != null"
                        v-html="
                          ' (<span style=color:#166BFF;>' + item.nick_name + '</span>)'
                        "
                      />
                      <span v-else>{{ item.nick_name }}</span>
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs6 pa-1>
                      <span>{{ $t("Salary") }} : </span>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                      <span v-show="currencySymbols == '0'" style="padding-left: 0px">
                        {{
                          symbolStyles + " " + formatNumber(item.amount, 2, true)
                        }}</span
                      >
                      <span v-show="currencySymbols == '1'" style="padding-left: 0px">
                        {{
                          formatNumber(item.amount, 2, true) + " " + symbolStyles
                        }}</span
                      >
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs6 pa-1>
                      <span>{{ $t("craftAmount") }} : </span>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                      <span
                        v-if="
                          item.craftamount != '' &&
                          item.craftamount != 0 &&
                          item.craftamount != null
                        "
                        >{{
                          formatNumber(item.craftamount, 2, true) + " " + symbolStyles
                        }}</span
                      >
                      <span v-else>- </span>
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs6 pa-1>
                      <span>{{ $t("PositionAmount") }} : </span>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                      <span
                        v-if="
                          item.positionamount != '' &&
                          item.positionamount != 0 &&
                          item.positionamount != null
                        "
                        >{{
                          formatNumber(item.positionamount, 2, true) + " " + symbolStyles
                        }}</span
                      >
                      <span v-else>- </span>
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs6 pa-1>
                      <span>{{ $t("effectdate") }} : </span>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                      <span> {{ selectedformatDates(item.approve_date) }}</span>
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs6 pa-1>
                      <span>{{ $t("remark") }} : </span>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                      <span v-if="item.remark != ''"> {{ item.remark }}</span>
                      <span v-else> -</span>
                    </v-flex>
                    <!-- <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-icon">
                        <v-icon style="padding-left: 0px;">access_time</v-icon>
                        <span>{{formatDate(item.approve_date, formatDates)}}</span>
                      </span>
                      <span class="coco-list-label-icon">
                        <v-icon>monetization_on</v-icon>
                        <span v-show="currencySymbols == '0'">
                          {{symbolStyles + ' ' + formatNumber(item.amount, 2,
                          true)}}
                        </span>
                        <span v-show="currencySymbols == '1'">
                          {{formatNumber(item.amount, 2, true) + ' ' +
                          symbolStyles}}
                        </span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up" v-show="isEmpty(item.remark)">
                      <span class="coco-list-label-icon">
                        <v-icon style="padding-left: 0px;">info</v-icon>
                        <span>{{ item.remark }}</span>
                      </span>
                    </v-flex>-->
                  </v-layout>
                </v-flex>
                <v-flex lg1 md1 sm1 xs2>
                  <v-layout row wrap>
                    <v-flex lg1 md2 sm2 xs2 text-xs-right>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-menu offset-y>
                          <template slot="activator">
                            <v-btn icon style="color: rgba(0, 0, 0, 0.54)">
                              <v-icon>fas fa-ellipsis-v</v-icon>
                            </v-btn>
                          </template>
                          <v-card class="pa-0" max-width="344">
                            <v-card-title
                              class="setbox"
                              v-if="permission_view == true || admin == 'true'"
                            >
                              <v-btn
                                color="orange"
                                slot="activator"
                                flat
                                @click="onHandleDialog(true, 'update', item)"
                              >
                                <v-icon>search</v-icon>
                                <span> {{ $t("view") }}</span>
                              </v-btn>
                            </v-card-title>
                            <v-card-title
                              class="setbox"
                              v-if="permission_edit == true || admin == 'true'"
                            >
                              <v-btn color="red" flat @click="deleteItem(item)">
                                <v-icon>delete</v-icon>
                                <span> {{ $t("delete") }}</span>
                              </v-btn>
                            </v-card-title>
                          </v-card>
                        </v-menu>
                      </v-card-actions>
                    </v-flex>
                  </v-layout>
                  <!-- <v-layout row wrap>
                        <v-flex offset-lg5 offset-md3 lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout> -->
                </v-flex>
                <!-- <v-flex xs12 class="hidden-sm-and-up">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-xs8 xs2 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs2 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <!-- <v-flex
                  xs12
                  offset-md1
                  offset-sm2
                  class="coco-list-divider"
                  style="margin-top : 10px; margin-bottom : 10px;"
                >
                  <v-divider />
                </v-flex> -->
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- pagination -->
      <v-layout row wrap my-2>
        <v-flex xs12>
          <div class="show_pagination_fixed">
            <v-pagination
              fixed
              v-model="pageActive"
              :length="totalPages"
              :total-visible="5"
              circle
              @input="getSalaryApproveList('List')"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <!-- Delete Dialog -->
      <v-flex xs12>
        <v-dialog v-model="delDialogStatus" persistent max-width="300">
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
                <span>{{ $t("info.confirm_delete") }}</span>
              </v-toolbar-title>
              <v-spacer />
              <v-btn icon dark @click="delDialogStatus = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-layout row wrap pa-3>
              <v-flex xs12>
                <v-card-text>
                  ต้องการลบเอกสารปรับเงินเดือน
                  <br />
                  พนักงาน :{{ delDialog.emp_code }} ใช่หรือไม่?
                </v-card-text>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs6 pa-1>
                  <v-btn color="error" outline block @click="delDialogStatus = false">{{
                    $t("cancel")
                  }}</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="success" outline block @click="onDelete()">{{
                    $t("submit")
                  }}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- FrmDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog" />
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import Empimage from "../../components/getempimage.vue";
import DocumentService from "@/services/DocumentService";
import UserService from "@/services/UserService";
import store from "@/store";
import Utils from "@/utils/";
import FrmDialog from "./FormDialog";
import $ from "jquery";
import FilterComponent from "./Filter";
export default {
  data: () => ({
    Search_data: "",
    show_search: false,
    dialog_data: {
      status: false,
      save_type: String,
      data: Object,
    },
    form_dialog_data: {
      status: false,
    },
    table_data: [],
    pageActive: 1,
    totalPages: 0,
    processing: false,
    canLoadMore: true,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: "",
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    timeout: null,
    admin: false,
    permission_edit: false,
    permission_view: false,
    empCode: localStorage._empcode,
    permission: [],
  }),
  created: async function () {
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    this.admin = localStorage._is_admin;
    await this.checkpermission("ChangeSalaryList");
    console.log(this.check_permission);
    this.commitSetToolbar({
      patternTool: "0",
    });

    await this.getSalaryApproveList("Form");
    await this.getEmployee("newData");
  },
  destroyed: function () {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  components: {
    Empimage,
    FrmDialog,
    FilterComponent,
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate",
    ]),
    ...mapState("app", ["showLoading", "formatDates", "symbolStyles", "currencySymbols"]),
    ...mapState("filter", ["Employee_List"]),
    //...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    ...mapActions("filter", ["getEmployee"]),
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.dialog_data.status = false;
      console.log("safasfasfasfasf");

        this.getSalaryApproveList();

    },

    onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
      console.log("xxxxxxx");
      this.commitSetShowLoading(true);
      setTimeout(() => {
        this.getSalaryApproveList();
      }, 1000);
    },
    showFilter(status) {
      this.form_dialog_data = {
        status: status,
        data: 1,
      };
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data,
      };
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        v.getSalaryApproveList("Filter");
      }, 1500);
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
        $("#pagetitleshow").removeClass("showtitlepage");
      } else {
        this.show_search = true;
        $("#pagetitleshow").addClass("showtitlepage");
      }
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    getSalaryApproveList(Action) {
      this.commitSetShowLoading(true);
      console.log(this.SelectBranch);
      console.log(this.SelectDepartment);
      DocumentService.getSalaryApproveList(
        this.SelectBranch,
        this.SelectDepartment,
        this.SelectPosition,
        this.Search_data,
        this.pageActive,
        this.FromDate,
        this.ToDate
      )
        .then((res) => {
          if (this.table_data.length > 0 && Action == "List") {
            if (res.data.content.length > 0) {
              res.data.content.forEach((data) => {
                this.table_data.push(data);
                console.log("tabledata", this.table_data);
              });
              this.totalPages = res.data.totalPages;
            } else {
              this.canLoadMore = false;
            }
          } else {
            this.table_data = res.data.content;
            this.totalPages = res.data.totalPages;
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = "";
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteSalaryApprove(this.delDialog.roworder)
        .then((res) => {
          this.showSnackBar("delete success", "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getSalaryApproveList();
          this.delDialogStatus = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

span,
strong {
  font-family: "Prompt", sans-serif;
}
.setbox {
  padding: 0px !important;
  text-align: left;
  width: 100px;
}
.coco-label-icon {
  padding-bottom: 5px !important;
}
.v-card__text {
  padding: 0px !important;
}
</style>
